import { render } from "./AccountsChangeOnTheWayList.vue?vue&type=template&id=3bcd8c02&scoped=true"
import script from "./AccountsChangeOnTheWayList.vue?vue&type=script&lang=js"
export * from "./AccountsChangeOnTheWayList.vue?vue&type=script&lang=js"

import "./AccountsChangeOnTheWayList.vue?vue&type=style&index=0&id=3bcd8c02&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcd8c02"]])

export default __exports__